<template>
        <div class="project-list">
            <h3 class="monospaced">$ ls -la ↵</h3>
            <project-item v-for="p in projects" :key="p.name" :project="p"></project-item>
        </div>
</template>

<script>
import ProjectItem from './ProjectItem.vue'

export default {
    name: 'ProjectList',
    data () {
        return {
            projects: []
        }
    },
    mounted () {
        this.fetchData()
    },
    methods: {
        fetchData: function () {
            var vm = this
            var xhr = new XMLHttpRequest()
            xhr.open('GET', '/static/garage.json')
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    var res = JSON.parse(xhr.responseText)
                    vm.projects = res.projects
                }
            }
            xhr.send()
        }
    },
    components: {
        ProjectItem
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.project-list {
    display: flex;
    flex-direction: column;
    text-align: left;
}

.project-list > h3{
    margin-top: 0;
    padding-left: 25px;
}

.project-list-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

</style>



// WEBPACK FOOTER //
// ProjectList.vue?924c806a